let language = {
    BULK_ORDER_CHECKOUT_STEP_BULK_ITEM_NULL: "拼单为空！"
};

export { language }
